/**
 * Generates an array of dates within a specified range, optionally excluding certain dates.
 *
 * @param range - A tuple containing the start and end dates of the range.
 * @param toExclude - An optional array of dates to exclude from the result.
 * @returns An array of dates within the specified range, excluding any dates in the `toExclude` array.
 */
export const generateIncludedDays = (range: [Date, Date], toExclude?: Date[]): Date[] => {
  const [start, end] = range

  const startTime = start.getTime()
  const endTime = end.getTime()

  const currentDate = new Date(Math.min(startTime, endTime))
  const endDate = new Date(Math.max(startTime, endTime))

  const dates: Date[] = []

  while (currentDate <= endDate) {
    if (!toExclude || !toExclude.some((excludeDate) => excludeDate.getTime() === currentDate.getTime())) {
      dates.push(new Date(currentDate))
    }
    currentDate.setDate(currentDate.getDate() + 1)
  }

  return dates
}
